<template>
  <div class="current-step-apge">
    <div class="one-step detail-step">
      結帳明細
    </div>
    <div class="step-line line-1"></div>
    <div class="one-step payment-step">
      付款
    </div>
    <div class="step-line line-2"></div>
    <div class="one-step invoice-step">
      開立發票
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style lang="scss"></style>
